<!--
 * @Author: your name
 * @Date: 2021-11-24 10:13:13
 * @LastEditTime: 2021-11-29 18:25:51
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: /static-pc/src/views/demand/DemandDetail.vue
-->
<template>
  <div class="container">
    <Nav/>
    <div class="content-wrapper">
      <el-row type='flex'>
        <div class="demand-image-wrapper">
          <div class="active-image" @mouseover='showPreview = true' @mouseout="showPreview = false" @mousemove='onMouseMove'>
            <img :src="activeImage" alt="">
            <div class="mouse-box" v-show="showPreview" :style="activeMoveStyle"></div>
          </div>
          <div class="image-preview-wrapper" v-show='showPreview'>
            <div class="overlay-img" :style="activePreviewStyle">
              <img :src="activeImage" alt="">
            </div>
          </div>
          <div class="demand-image-list-wrapper">
            <div class="demand-image-item" v-for="(item, index) in imageList" :key="index" @mouseover='onSelectImage(item)'>
              <img :src="item.small" alt="">
            </div>
          </div>
        </div>
        <div class="demand-top-content">
          <div class="demand-title">{{demandTitle}}</div>
          <div class="demand-fix">
            <el-tag size='small' v-for="(v, index) in keywordList" :key='index' type='warning' class="tag-margin">{{v}}</el-tag>
          </div>
          <div class="demand-info-item" v-if="item.name && item.value" v-for="(item,index) in baseItemList" :key="index">
            <div class="item-label">
              <span v-for="(k,index) in itemLabelList(item.name)" :key='k'>{{k}} {{index === itemLabelList(item.name).length - 1 ? '：':''}}</span>
            </div>
            <span class="item-value">{{item.value || '/'}}</span>
          </div>
          <div class="fix-info">* 本信息仅供医学药学人士阅读</div>
        <el-popover
          trigger='hover'
          placement='right'
        >
          <div class="qr-wrapper">
            <img :src="require('@/assets/common/app_qr.png')" class="app-qr-image" alt="">
            <div>扫码下载药脉通APP</div>
          </div>
          <el-button slot="reference" type='primary' icon='el-icon-phone' class="demand-btn">获取联系电话</el-button>
        </el-popover>
        </div>
      </el-row>
      <el-row type='flex' class="demand-tab">
        <div class="recommend-wrapper">
          <div class="recommend-section">相关产品推荐</div>
          <div class="recommend-list-wrapper">
            <div class="recommend-item-wrapper" v-for="v in recommendDemandList" :key='v.demandId' @click="onJumpDemand(v.showInfo.params.product.sellerDemandId)">
              <el-row type='flex'>
                <el-image class="recommend-item-image" :src='v.showInfo.params.product.imageVO && v.showInfo.params.product.imageVO.small'></el-image>
                <div class="recommend-item-content">
                  <div class="font-weight text-ellipsis title">{{v.showInfo.params.product.title}}</div>
                  <div class="text-ellipsis">{{v.showInfo.params.user.enterpriseName}}</div>
                </div>
              </el-row>
            </div>
            <div class="recommend-more" v-if="recommendDemandList.length > 0" @click="onJumpMore">
              <span>更多产品</span>
              <i class="el-icon-arrow-right"></i>
            </div>
          </div>
        </div>
        <el-tabs v-model="activeTab">
          <el-tab-pane label="产品详情" name="first"></el-tab-pane>
          <el-tab-pane label="招商要求" name="second"></el-tab-pane>
          <div v-if="activeTab === 'first'">
            <div>
              {{detailText}}
            </div>
            <div class="detail-image">
              <img :src="item.large" alt="" v-for="(item,index) in detailImageList" :key='index'>
            </div>
          </div>
          <div v-if="activeTab === 'second'">
            <div class="demand-info-item" v-if="item.name && item.value" v-for="(item,index) in etfItemList" :key="index">
              <div class="item-label">
                <span v-for="(k,index) in itemLabelList(item.name)" :key='k'>{{k}} {{index === itemLabelList(item.name).length - 1 ? '：':''}}</span>
              </div>
              <span class="item-value">{{item.value || '/'}}</span>
            </div>
          </div>
        </el-tabs>
      </el-row>
    </div>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import Nav from '@/layout/Nav'
export default {
  name: 'DemandDetail',
  data () {
    return {
      showPreview: false,
      activeImage: '',
      offsetMoveX: 0,
      offsetMoveY: 0,
      imageList: [],
      demandTitle: '',
      keywordList: [],
      baseItemList: [],
      etfItemList: [],
      imageOffsetMoveY: 0,
      imageOffsetMoveX: 0,
      activeTab: 'first',
      detailText: '',
      detailImageList: [],
      recommendDemandList: []
    }
  },
  components: {
    Nav
  },
  computed: {
    itemLabelList () {
      return (val)=>{
        return (val || '').split('')
      }
    },
    recommendDemandTitle () {
      return (val)=>{
        return (val || '').split('')
      }
    },
    activeMoveStyle () {
      return {
        top: `${this.offsetMoveY}px`,
        left: `${this.offsetMoveX}px`
      }
    },
    activePreviewStyle () {
      return {
        top: `${this.imageOffsetMoveY}px`,
        left: `${this.imageOffsetMoveX}px`
      }
    }
  },
  methods: {
    ...mapActions(['getDemandDetail','getRecommendDemandList']),
    onJumpDemand (demandId) {
      window.open(`/demand/detail/${demandId}`)
    },
    onJumpMore () {
      window.open(`/demand/list`)
    },
    onSelectImage (item) {
      this.activeImage = item.large
    },
		//图片预览
		onMouseMove($event){
			var x = ($event.currentTarget.getBoundingClientRect().left-$event.clientX)
			var y = ($event.currentTarget.getBoundingClientRect().top-$event.clientY)
			//处理放大图片
			if(x<=-284){
				this.imageOffsetMoveX = -382
			}else if(x>=-95){
				this.imageOffsetMoveX = -1
			}else{
				this.imageOffsetMoveX = ($event.currentTarget.getBoundingClientRect().left-$event.clientX)*2+190
			}
			if(y<=-284){
				this.imageOffsetMoveY = -382
			}else if(y>=-95){
				this.imageOffsetMoveY = -1
			}else{
				this.imageOffsetMoveY = ($event.currentTarget.getBoundingClientRect().top-$event.clientY)*2+190
			}
			//处理move方框
			if(x>=-95){
				this.offsetMoveX = 0
			}else if(x<=-290){
				this.offsetMoveX = 188
			}else{
				this.offsetMoveX = Math.abs(x)-95
			}
			if(y>=-95){
				this.offsetMoveY = 0
			}else if(y<=-290){
				this.offsetMoveY = 188
			}else{
				this.offsetMoveY = Math.abs(y)-95
			}
			console.log(this.offsetMoveX)
		}
  },
  mounted () {
    this.demandId = this.$route.params.id || ''
    this.getDemandDetail(this.demandId).then(res=>{
      const {demand} = res
      this.imageList = demand.cover
      this.activeImage = this.imageList[0].large
      this.demandTitle = demand.title
      this.keywordList = demand.keywords
      this.detailText = demand.detail
      this.detailImageList = demand.detailImg || []
      demand.nodes.map(v=>{
        if (v.name === '产品基础信息') {
          this.baseItemList = v.attrItems
        }
        if (v.name === '招商要求') {
          this.etfItemList = v.attrItems
        }
      })
    },rea=>{
    })
    this.getRecommendDemandList().then(res=>{
      this.recommendDemandList = res
    },rea=>{

    })
  }
}
</script>
<style lang="scss" scoped>
  .content-wrapper {
    padding-top: 40px;
    border-top: 1px solid #EEEEEE;
    position: relative;
    max-width: 1280px;
    margin: 0 auto;
  }
  .demand-image-wrapper {
    position: relative;
    .active-image {
      height: 100%;
      cursor: move;
      width: 100%;
      overflow: hidden;
      width: 380px;
      height: 380px;
      line-height: 380px;
      text-align: center;
      vertical-align: middle;
      background-color: #E6E6E6;
    }
    img {
      width: 100%;
      max-height: 100%;
    }
    .mouse-box {
      width: 190px;
      height: 190px;
      background: rgba(0,0,0,0.3);
      position: absolute;
      top: 0;
      left: 0;
      z-index: 1001;
    }
  }
  .image-preview-wrapper {
    position: absolute;
    width: 380px;
    height: 380px;
    border: 1px solid; 
    z-index: 1000;
    background: white;
    left: calc(100% + 20px);
    top: 0;
    border: 1px solid #CCC;
    overflow: hidden;
  }
  .overlay-img {
      position: absolute;
      top: 0;
      left: 0;
      width: 760px;
      height: 760px;
      line-height: 760px;
      text-align: center;
      vertical-align: middle;
      img {
        max-width: 100%;
        max-width: 100%;
      }
  }
  .demand-image-list-wrapper {
    margin-top: 20px;
    display: flex;
    .demand-image-item {
      cursor: pointer;
      width: 60px;
      height: 60px;
      flex-shrink: 0;
      display: flex;
      position: relative;
      margin-right: 10px;
      border: 2px solid #E6E6E6;
      img {
        background-color: #E6E6E6;
        max-width: 100%;
        max-height: 100%;
      }
      &:hover {
        border-color:#0F0F0F;
      }
    }
  }
  .demand-top-content {
    padding-left: 28px;
    flex: 1;
  }
  .demand-title {
    font-size: 24px;
    font-weight: bolder;
  }
  .tag-margin {
    margin-right: 10px;
    border: none;
  }
  .demand-fix {
    padding-top: 10px;
    padding-bottom: 10px;
    border-bottom: 1px solid #F0F0F0;
    margin-bottom: 14px;
  }
  .demand-info-item {
    padding-top: 6px;
    padding-bottom: 6px;
    line-height: 1;
    font-size: 14px;
    display: flex;
    .item-label {
      color: #787878;
      flex-shrink: 0;
      min-width: 80px;
      display: flex;
      justify-content: space-between;
    }
  }
  .fix-info {
    color: #B4B4B4;
    font-size: 12px;
    margin-top: 20px;
    margin-bottom: 25px;
  }
  .demand-btn {
    border-radius: 0;
    height: 60px;
    width: 200px;
    font-size: 18px;
  }
  .demand-tab ::v-deep {
    margin-top: 25px;
    padding-bottom: 30px;
    .el-tabs {
      border: 1px solid #F0F0F0;
      padding-bottom: 30px;
      flex: 1;
      min-height: 500px;
    }
    .el-tabs__header {
      background-color: #f5f5f5;
      .el-tabs__active-bar {
        display: none;
      }
      .el-tabs__item {
        height: 40px;
        line-height: 40px;
        color: #787878;
        width: 120px;
        text-align: center;
        padding: 0;
        transition: all 150ms;
        &:hover {
          color: #5259D6;
        }
        &.is-active {
          background-color: #5259D6;
          color: #fff;
        }
      }
    }
    .el-tabs__content {
      padding-left: 33px;
      padding-top: 5px;
      font-size: 16px;
    }
    .detail-image {
      margin-top: 15px;
      img {
        max-width: 100%;
        display: block;
      }
    }
  }
  .recommend-wrapper {
    margin-right: 18px;
    flex-shrink: 0;
    border: 1px solid #F0F0F0;
    .recommend-section {
      background-color: #EEEEEE;
      color: #0F0F0F;
      font-size: 14px;
      height: 40px;
      line-height: 40px;
      padding-left: 20px;
      width: 14.5vw;
      max-width: 290px;
    }
    .recommend-list-wrapper {
      padding-left: 10px;
      padding-right: 10px;
    }
    .recommend-item-wrapper {
      padding-top: 15px;
      padding-bottom: 15px;
      cursor: pointer;
      border-bottom: 1px solid #F0F0F0;
      .recommend-item-image {
        width: 80px;
        height: 80px;
        flex-shrink: 0;
        margin-right: 10px;
      }
      .recommend-item-content {
        padding-top: 8px;
        padding-bottom: 5px;
        display: flex;
        color: #787878;
        flex-direction: column;
        &:hover {
          opacity: 0.7;
        }
        .title {
          padding-bottom: 6px;
          color: #232323;
        }
      }
    }
    .recommend-more {
      padding-top: 15px;
      cursor: pointer;
      font-size: 14px;
      color: #333;
      text-align: right;
    }
  }
</style>